import posthog from 'posthog-js';
import type { AnalyticsEventName, AnalyticsEventProperties } from './events';

let initialized = false;

export const initializeAnalytics = (): void => {
  const mode = import.meta.env.MODE;
  const posthogKey = import.meta.env.VITE_POSTHOG_KEY;
  const posthogHost = import.meta.env.VITE_POSTHOG_HOST;

  if (mode === 'production' && posthogKey) {
    posthog.init(posthogKey, {
      api_host: posthogHost ?? 'https://app.posthog.com',
      capture_pageview: true,
      autocapture: false,
      disable_session_recording: false,
      session_recording: {
        maskAllInputs: true,
        maskTextSelector: '[data-sensitive]',
      },
    });
    initialized = true;
  }
};

export const trackEvent = (
  eventName: AnalyticsEventName,
  properties?: AnalyticsEventProperties
): void => {
  const mode = import.meta.env.MODE;
  if (mode === 'production' && initialized) {
    posthog.capture(eventName, properties);
  }
};

export const isAnalyticsEnabled = (): boolean => {
  const mode = import.meta.env.MODE;
  return mode === 'production' && initialized;
};

export const resetAnalytics = (): void => {
  initialized = false;
};
